import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { BlueContainer, Button, Badge } from '@app/shared/ui/atoms/Common';
import { ListItemRow } from '@app/shared/ui/atoms/Admin/Withdrawals';
import { formatBalance, formatFrozenBalance } from '@app/shared/utils/common';
import { Page } from '@app/routes';
import { PriceType } from '@app/shared/types/common';
import { User } from '@app/shared/types/admin/pages/users';

interface ListItemProps {
  user: User;
}

export function ListItem({ user }: ListItemProps) {
  const { t } = useTranslation();

  return (
    <BlueContainer withShadow className="flex flex-col items-center gap-2 md:flex-row" asChild>
      <li>
        <div className="flex flex-1 flex-col gap-1">
          <ListItemRow label="ID" value={<b>{user.id}</b>} />
          <ListItemRow label={t('common.name')} value={<b>{user.fullName}</b>} />
          <ListItemRow label="Telegram" value={<b>{user.telegramUsername}</b>} />
          <ListItemRow label="Telegram ID" value={<b>{user.telegramId}</b>} />
          <ListItemRow
            label={t('common.balance')}
            value={
              <div className="flex gap-2">
                <Badge className="border border-accent">
                  {formatBalance(PriceType.COOKIE, user.cookieBalance)}
                </Badge>
                <Badge className="border border-accent">
                  {formatBalance(PriceType.TON, user.tonBalance)}
                </Badge>
                {!!user.frozenTonBalance && (
                  <Badge className="border border-accent">
                    {formatFrozenBalance(user.frozenTonBalance)}
                  </Badge>
                )}
              </div>
            }
          />
        </div>

        <Button
          variant="secondary"
          size="sm"
          className="flex w-fit items-center justify-center px-2.5"
          asChild
        >
          <Link to={`${Page.ADMIN_USERS}/${user.id}`}>{t('common.open')}</Link>
        </Button>
      </li>
    </BlueContainer>
  );
}
